import { Hidden } from '@mui/material'
import { GetStaticProps, NextPage } from 'next'
import { useRouter } from 'next/router'
import React, { useState } from 'react'
import { ContentPagination } from 'src/components/ContentPagination/ContentPagination'
import { ExpertsCarousel } from 'src/components/ExpertsCarousel/ExpertsCarousel'
import { Footer } from 'src/components/Footer/Footer'
import MainContainer from 'src/components/global/MainContainer/MainContainer'
import { PremiumModal } from 'src/components/global/PremiumModal'
import { SearchField } from 'src/components/global/SearchField'
import { Sidebar } from 'src/components/global/Sidebar'
import { ThemeOnly } from 'src/components/global/ThemeOnly'
import { ReCaptcha } from 'src/components/ReCaptcha/ReCaptcha'
import { THEME } from 'src/config/config'
import { IEnum_Content_Contenttype } from 'src/graphql/generated/hooks'
import { useDecodedKeyword } from 'src/hooks/useGetDecodeKeyword'
// import { useAuthenticated } from 'src/hooks/useAuthenticated'
import { Meta } from 'src/layout/Meta'
import { Main } from 'src/templates/Main'
import { FilterOption } from 'src/types'
import {
  getAudiencesFilter,
  getAuthorsFilter,
  getDateFilter,
  getDocumentTypesFilter,
  getSubjectsFilter,
} from 'src/utils/ContentFilters/contentFilters'

type Props = {
  filters: FilterOption[]
}

const KnowHowPage: NextPage<Props> = ({ filters }: Props) => {
  const router = useRouter()
  const [showModal, setShowModal] = useState(false)
  const title = 'Know-How'
  const description =
    'Know how about digital transformation, knowledge management and innovation in law firms and in-house legal departments'

  const searchKeyword = useDecodedKeyword(router.query.keyword)

  // const { isPremium } = useAuthenticated()
  // const filtersDisabled = useMemo(() => !isPremium, [isPremium])
  const handleCloseModal = () => {
    setShowModal(false)
  }

  const meta = <Meta title={title} url={`/know-how`} description={description} />
  return (
    <ReCaptcha>
      <Main meta={meta}>
        <PremiumModal origin="/know-how/" isOpen={showModal} onClose={handleCloseModal} />
        <MainContainer id="mainContainer">
          <div className="flex flex-col bg-clouds">
            {/* <Breadcrumb className="justify-start" subject="INDUSTRY ANALYSIS" subjectRoute={`/`} subtitle="KNOW-HOW" /> */}
            <div className="px-5 md:pl-0 !max-w-[1100px] w-full mx-auto flex flex-row items-center pt-2">
              <div className="flex-row flex mt-[1rem] mb-[3rem] w-2/3">
                <div className="flex flex-col" style={{ justifyContent: 'center' }}>
                  <h1 className="pt-[0.5rem] pb-[0.625rem] text-[1.875rem] font-bold font-secondary text-[#333333]">
                    Know-How
                  </h1>
                  <h2
                    style={{ fontWeight: 450 }}
                    className=" text-[0.9375rem] font-primary font-regular text-[#333333]"
                  >
                    Know how about digital transformation, knowledge management and innovation in law firms and in-house
                    legal departments
                  </h2>
                </div>
              </div>
            </div>
          </div>
          <hr />
          <div className="flex flex-col justify-center w-full md:pl-0 md:pr-0 pl-[20px] pr-[20px]">
            <div className="flex flex-row justify-center w-full">
              <div className="!max-w-[1100px] flex flex-row justify-between w-full mb-32">
                <Hidden mdDown>
                  <div className="w-1/4 pr-10 flex flex-col">
                    <SearchField className="my-8" />
                    <Sidebar
                      filterOptions={filters}
                      // filtersDisabled={filtersDisabled}
                      defaultSelectFilterIdx={1}
                      onClickWhenDisabled={() => setShowModal(true)}
                    />
                  </div>
                </Hidden>

                <ContentPagination
                  filterProps={filters}
                  // filtersDisabled={filtersDisabled}
                  onClickWhenDisabled={() => setShowModal(true)}
                  contentType={IEnum_Content_Contenttype.KnowHow}
                  searchKeyword={searchKeyword}
                />
              </div>
            </div>
            <ExpertsCarousel />
          </div>
          <ThemeOnly theme="legaltech">
            <Footer />
          </ThemeOnly>
        </MainContainer>
      </Main>
    </ReCaptcha>
  )
}

export default KnowHowPage

export const getStaticProps: GetStaticProps<Props> = async ({}) => {
  if (THEME === 'ilta')
    return {
      revalidate: 60,
      notFound: true,
    }
  try {
    const filters: FilterOption[] = await Promise.all([
      getAudiencesFilter(),
      getSubjectsFilter({ includeSubjectMatters: true, includeThemes: false }),
      getDocumentTypesFilter(),
      getAuthorsFilter({ includeAuthors: true, includeExperts: true }),
      getDateFilter(),
    ])
    return {
      props: {
        filters,
      },
      revalidate: 60,
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error occurred in getStaticProps of Know-How:', error)
    // Graceful fallback in case of an upstream error
    return {
      notFound: true,
      revalidate: 5, // Reattempt fetching during the next static regeneration
    }
  }
}
